import { CustomIconsMap } from '@core';

export const CUSTOM_ICONS = [
  'ico_cart',
  'ico_alert',
  'ico_heart',
  'ico_account',
  'ico_credit_card',
  'ico_caret_left',
  'ico_caret_right',
  'ico_minus',
  'ico_minus_outlined',
  'ico_caret_down',
  'ico_plus',
  'ico_plus_outlined',
  'ico_arrow_right',
  'ico_arrow_left',
  'ico_caret',
  'ico_category',
  'ico_checkmark_filled',
  'ico_close',
  'ico_search',
  'ico_tag',
  'ico_soft',
  'ico_heart_filled',
  'ico_info',
  'ico_info_current_color',
  'ico_checkmark',
  'ico_trash',
  'ico_cart_empty',
  'ico_edit',
  'ico_accordion_caret_right',
  'ico_visa_card',
  'ico_mastercard_card',
  'ico_brand_logo',
  'ico_play',
  'ico_pause',
  'ico_vector',
] as const;

export const CUSTOM_ICONS_MAP: CustomIconsMap<(typeof CUSTOM_ICONS)[number]> = CUSTOM_ICONS.reduce(
  (result, iconName) => {
    result[iconName] = `/assets/images/icon/${iconName}.svg`;
    return result;
  },
  {} as CustomIconsMap<(typeof CUSTOM_ICONS)[number]>,
);
